<template>
  <v-progress-linear
    :value="percent"
    :color="colorBar"
    :height="heightBar"
    :background-color="colorBkgd"
    class="border"
    disabled="true"
  >
      <p class="ntitlesdark--text text-carga font-weight-bold ma-0">{{ Math.ceil(percent) }}% {{ Math.ceil(percent) >= 10 && 90 > percent  ? title : ''}}</p>
  </v-progress-linear>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    percent: {
      type: Number,
      default: 30
    },
    colorBar: {
      type: String,
      default: "error"
    },
    title: {
      type: String,
      default: "Cargando"
    },
    colorBkgd: {
      type: String,
      default: "white"
    },
    heightBar: {
      type: String,
      default: "50"
    },
  }
}
</script>

<style scoped>
.text-carga {
  font-size: 1em;

}
</style>
